import { combineReducers } from 'redux';

import data from './data';
import ui from './ui';

/**
 * @typedef {{
 *   ui: import('./ui').AuditModelUIReducer,
 *   data: import('./data').AuditModelDataReducer,
 * }} AuditModelReducer
 */

export default combineReducers({
  ui,
  data,
});
